import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import EditableForm from '../Form/EditableForm';
import { copyProjectByUser, putResultadoById } from '../../controllers/operaciones';
import { iDataProyectoPorUsuario } from '../../interfaces/iDataProyectoPorUsuario';
import { useAuthContext } from '../../hooks/Auth';
import { useCustomAlert } from '../utils/CustomAlert/useCustomAlert';
import { CustomAlert } from '../utils/CustomAlert/CustomAlert';
import { ChatUIProvider } from '../UmmIAChatAI/ChatUIContext';
import EdicionCardImg from "../../components/UmmIApps/Cards/EdicionCardImg.svg";
import { useActividadesContext } from '../UmmIACategories/Hook/useActividades';
import EditProjectLayout from '../UmmIACategories/Layout/EditProjectLayout';


function DetalleProyecto() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const proyecto = (location.state as any)?.proyecto;
  const keys = (location.state as any)?.keys;

  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuthContext();
  const {  showAlert } = useCustomAlert();

  const {
    handleBack,
  } = useActividadesContext();

  useEffect(() => {
    if (id && proyecto && keys) setIsLoading(false);
  }, [id, proyecto, keys]);

  const handleCancelar = () => {
    navigate('/asistente/myprojects', { state: { fromDetail: true } });
  };

  const handleSaveProject = async (
    proyectoId: string,
    usuarioId: string,
    resultadoId: string,
    proyectoObjPropuesta: iDataProyectoPorUsuario['propuesta']
  ) => {
    if (!user) {
      showAlert('No se pudo establecer el usuario para el requerimiento', 'error');
      throw new Error('No se pudo establecer el usuario para el requerimiento');
    }

    if (usuarioId === user.id) {
      try {
        const response = await putResultadoById(proyectoId, resultadoId, proyectoObjPropuesta);
        if (response) {
          handleCancelar();
          return;
        }
      } catch (error) {
        console.error('handleSaveProject Error', error);
        showAlert('Error al guardar proyecto', 'error');
      }
    }

    await copyProjectByUser(proyectoId, user.id, resultadoId, proyectoObjPropuesta);
    showAlert('¡Proyecto copiado exitosamente!', 'success');
    handleCancelar();
  };

  if (!proyecto || !keys) {
    return (
      <ChatUIProvider>
        <div style={{ padding: 24 }}>
          <CustomAlert />
          <p>No se encontró información del proyecto. Regresando…</p>
          <button onClick={handleCancelar}>Volver</button>
        </div>
      </ChatUIProvider>
    );
  }



  return (
    <ChatUIProvider>
      <EditProjectLayout
        onBack={handleBack}
        imageSrc={EdicionCardImg}
        backgroundColorImage={"linear-gradient(260deg, #FFFFFF 0%, #cececeff 100%, #4d4d4dff 100%)"}
        titleColor="#4e4e4eff"
        title="Modo edición"
        description=""
        isButtonDisabled={false}
        onGuardarProyecto={handleSaveProject}
        colorIconBack={"#4e4e4eff"}>

        <div>
          <CustomAlert />
          {!isLoading && (
            <EditableForm
              index={0}
              itemProyecto={proyecto}
              labels={keys}
              handleCancelar={handleCancelar}
              handleGuardar={handleSaveProject}
            />
          )}
        </div>
      </EditProjectLayout>
    </ChatUIProvider>
  );
}

export default DetalleProyecto;
